import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import Seo from "@/components/Seo";
import { LogoMark } from "@/components/Logo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page introuvable | FuiteX" description="La page recherchée est introuvable." />
      <section className="min-h-[100svh] bg-ink flex items-center justify-center grain relative overflow-hidden">
        <div className="absolute -top-20 right-0 h-96 w-96 rounded-full bg-aqua/20 blur-3xl" />
        <div className="container-x relative z-10 text-center">
          <LogoMark size={64} className="mx-auto" />
          <h1 className="mt-8 text-7xl sm:text-9xl font-extrabold tracking-tighter text-white">404</h1>
          <p className="mt-4 text-lg text-white/70 max-w-md mx-auto">
            Cette page est aussi invisible qu'une fuite d'eau… mais nous savons retrouver l'essentiel.
          </p>
          <Link to="/" className="mt-8 inline-flex btn-cta"><Home size={18} /> Retour à l'accueil</Link>
        </div>
      </section>
    </>
  );
}
